// El prompt del asistente operativo, editable desde el panel · AO5
//
// Lo que el modelo lee antes de cada pregunta. Vive en la base
// (asistente_prompt), nunca en código; vacío = el texto de omisión, que
// es el del dueño. Va dentro de Interesados, donde el dueño ya mira a su
// bot (lo monta el integrador).
import { useCallback, useEffect, useState } from 'react';
import { BrainCog, Save } from 'lucide-react';
import { apiPanel } from '../panel/api';
import Ayuda from '../ui/Ayuda';

export default function PromptDelAsistente() {
  const [abierto, setAbierto] = useState(false);
  const [prompt, setPrompt] = useState(null);
  const [valor, setValor] = useState('');
  const [error, setError] = useState(null);
  const [guardado, setGuardado] = useState(false);

  const cargar = useCallback(() => {
    apiPanel.get('/asistente/prompt')
      .then((p) => { setPrompt(p); setValor(p.valor || ''); setError(null); })
      .catch((e) => setError(e.message));
  }, []);
  useEffect(() => {
    if (!abierto) return undefined;
    const t = setTimeout(cargar, 0);
    return () => clearTimeout(t);
  }, [abierto, cargar]);

  const guardar = () => {
    setGuardado(false);
    apiPanel.post('/asistente/prompt', { valor })
      .then((p) => { setPrompt(p); setValor(p.valor || ''); setGuardado(true); setError(null); })
      .catch((e) => setError(e.message));
  };

  return (
    <section className="mt-6 rounded-xl border bg-white">
      <button type="button" onClick={() => setAbierto((v) => !v)} className="w-full flex items-center gap-3 p-4 text-left">
        <BrainCog className="h-5 w-5 text-gray-500 shrink-0" />
        <span className="flex-1">
          <span className="block font-semibold text-gray-900">Las instrucciones del asistente operativo</span>
          <span className="block text-sm text-gray-500">Lo que el modelo lee antes de cada pregunta. Las cifras y el «dato al» los pone TEGO, no el modelo.</span>
        </span>
        <span className="text-sm text-blue-700">{abierto ? 'Cerrar' : 'Editar'}</span>
      </button>
      {abierto && (
        <div className="border-t p-4 space-y-3">
          <Ayuda id="asistente.prompt" />
          {error && <p role="alert" className="rounded-lg bg-red-50 p-2 text-sm text-red-800">{error}</p>}
          {!prompt ? <p className="text-sm text-gray-500">Cargando…</p> : (
            <>
              <label className="block text-sm">
                <span className="font-semibold text-gray-800">Instrucciones de sistema</span>
                <span className="block text-xs text-gray-500">{prompt.ayuda}</span>
                <textarea value={valor} onChange={(e) => setValor(e.target.value)} rows={14} maxLength={8000}
                  placeholder={prompt.omision}
                  className="mt-1 w-full rounded-lg border border-gray-300 p-2 font-mono text-xs" />
              </label>
              <p className="text-xs text-gray-500">
                {valor.trim() ? `${valor.length} caracteres. Vacía el cuadro para volver al texto de omisión.` : 'Vacío: se usa el texto de omisión (el que ves en gris).'}
                {prompt.actualizado_en && ` Último cambio: ${new Date(prompt.actualizado_en).toLocaleString('es-MX')} por ${prompt.actualizado_por}.`}
              </p>
              <div className="flex items-center gap-3">
                <button type="button" onClick={guardar} className="inline-flex items-center gap-1 rounded-lg bg-gray-900 px-3 py-2 text-sm font-semibold text-white">
                  <Save className="h-4 w-4" /> Guardar
                </button>
                {guardado && <span className="text-sm text-green-700">Guardado. Aplica desde la siguiente pregunta.</span>}
              </div>
            </>
          )}
        </div>
      )}
    </section>
  );
}
